import React, { useState } from "react";
import {
    useGetSubAdminsQuery,
    useDeleteSubAdminMutation,
} from "../../../Slices/rollManager/subAdmin.slice";
import { IoSearch } from "react-icons/io5";
import { MenuBar } from "components/layout/MenuBar";
import Nav from "components/layout/Nav";
import { SubAdminTable } from "components/shared/table";
import { CreateLocation } from "components/shared/buttons";
import { useNavigate } from "react-router-dom";
import CreateSubAdmin from "components/forms/createSubAdmin";

const RollManager = () => {
    const { data: subAdmins, error, isLoading } = useGetSubAdminsQuery();
    const [deleteSubAdmin] = useDeleteSubAdminMutation();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [showForm, setShowForm] = useState(false);

    const filteredSubAdmins = subAdmins
        ? subAdmins.filter((admin) =>
            (admin.name && admin.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (admin.id && admin.id.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        : [];

    const handleViewProfile = (subAdmin) => {
        navigate(`/roleManager/profile/${subAdmin.id}`);
    };

    // ✅ Handle Delete Sub-Admin
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this Sub-admin?");
        if (confirmDelete) {
            try {
                await deleteSubAdmin(id).unwrap();
                alert("✅ Sub-Admin deleted successfully!");
            } catch (error) {
                alert("❌ Failed to delete Sub-Admin. Please try again");
                console.error("❌ Error deleting Sub-Admin:", error);
            }
        }
    };

    const renderEditorsSubTable = (editors = []) => {
        if (!editors.length) {
            return <p style={{ margin: 0, color: "#64748b" }}>No editors created yet.</p>;
        }

        return (
            <div className="tableWrapper" style={{ marginTop: "10px" }}>
                <div className="tableContainer">
                    <table border="1">
                        <thead>
                            <tr>
                                <th className="srNo">Sr. No</th>
                                <th>Editor ID</th>
                                <th>Name</th>
                                <th>Contact</th>
                                <th>Location</th>
                                <th>Segments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {editors.map((editor, index) => (
                                <tr key={editor.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{editor.id}</td>
                                    <td>{editor.name || "N/A"}</td>
                                    <td>{editor.contactNumber || editor.contactInfo || "N/A"}</td>
                                    <td>{editor.location || editor.district || "N/A"}</td>
                                    <td style={{ maxWidth: 240 }}>
                                        {editor.assignedSections?.length
                                            ? editor.assignedSections.join(", ")
                                            : "Not assigned"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    return (
        <>
            <Nav />
            <div className="row">
                <MenuBar />
                <main style={{ width: "calc(100vw - 240px)", backgroundColor: "#f5f7fb", minHeight: "100vh" }}>
                    <div style={{ padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "12px",
                            }}
                        >
                            <div>
                                <p style={{ margin: 0, color: "#64748b", fontWeight: 600, letterSpacing: "0.5px" }}>
                                    Admin Controls
                                </p>
                                <h2 style={{ margin: "6px 0 0", fontWeight: 700, color: "#0f172a" }}>
                                    Role Manager
                                </h2>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                                <div
                                    style={{
                                        position: "relative",
                                        minWidth: "260px",
                                        flex: "1 1 260px",
                                        maxWidth: "340px",
                                    }}
                                >
                                    <IoSearch
                                        style={{
                                            position: "absolute",
                                            left: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "#94a3b8",
                                            fontSize: "18px",
                                        }}
                                    />
                                    <input
                                        type="search"
                                        placeholder="Search ID, Name"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "42px",
                                            borderRadius: "10px",
                                            border: "1px solid #dbe2ea",
                                            background: "#ffffff",
                                            color: "#0f172a",
                                            padding: "0 14px 0 38px",
                                        }}
                                    />
                                </div>
                                <CreateLocation
                                    buttonText={"Add Sub-Admin"}
                                    showForm={showForm}
                                    setShowForm={setShowForm}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                background: "#ffffff",
                                borderRadius: "16px",
                                padding: "18px",
                                boxShadow: "0 12px 40px rgba(15, 23, 42, 0.08)",
                            }}
                        >
                            <h3 style={{ marginBottom: "12px", fontWeight: 700 }}>Location Manager List</h3>

                            {isLoading && <p>Loading Sub-Admins...</p>}
                            {error && <p style={{ color: "red" }}>❌ Error: {error.message}</p>}

                            {subAdmins && (
                                <SubAdminTable
                                    subAdmins={filteredSubAdmins}
                                    viewProfile={handleViewProfile}
                                    deleteConfirmation={handleDelete}
                                    renderEditorsSubTable={renderEditorsSubTable}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </div>

            {/* ✅ Ensure CreateSubAdmin receives setShowForm correctly */}
            {showForm && (
                <CreateSubAdmin 
                    showForm={showForm} 
                    setShowForm={setShowForm} 
                />
            )}
        </>
    );
};

export default RollManager;
